import React, { useState, useRef, useContext } from 'react';
import icon_menu_dots from 'images/icon_menu_dots.svg';
import 'antd/dist/antd.css';
import { Button, Modal, message } from 'antd';
import { useOnClickOutside } from 'hooks/useOnClickOutside';
import { cloneDeep, set } from 'lodash';
import icon_rename from 'images/new_pop_ups/rename.svg';

import { deleteProject } from 'services/home';
import {
    changeProjectName,
    duplicateProject,
    downloadProjectFile
} from 'services/project.js';
import DeleteModal from 'components/content/newModal/DeleteModal';
import ProjectDuplicateModal from 'components/content/newModal/ProjectDuplicateModal';
import RenameModal from 'components/content/newModal/RenameModal';
import { AppContext } from 'context/AppContext';

const ProjectDropdownToUnfinishedData = ({
    location,
    row,
    dataTable,
    setDataTable,
    handleTableRender,
    hideDelete,
    handleRefreshProject,
    hideExportAnalysis
}) => {
    let appContext = useContext(AppContext);

    const [dropdownVisible, setDropdownVisible] = useState(false);

    const [projectName, setProjectName] = useState();
    const [currentProjectId, setCurrentProjectId] = useState();
    const [currentFileId, setCurrentFileId] = useState();
    const [isModalDuplicate, setIsModalDuplicate] = useState(false);
    const [isModalDelete, setIsModalDelete] = useState(false);

    const [isModalRename, setIsModalRename] = useState(false);

    const ref = useRef();
    useOnClickOutside(ref, () => setDropdownVisible(false));

    const handleOpen = () => {
        setDropdownVisible(!dropdownVisible);
    };

    const handleOpenModalDuplicate = (data) => {
        setCurrentProjectId(data.id);
        setProjectName(data.name);
        setIsModalDuplicate(true);
    };

    const handleOkDuplicate = () => {
        duplicateProject(currentProjectId, projectName).then((res) => {
            setIsModalDuplicate(false);
            if (res.status == 200) {
                message.success('Project cloned successfully!');
                setTimeout(() => {
                    window.location.href = `/app/project/${res.data.created_id}`;
                }, 1000);
            }
        });
    };

    const handleCancelDuplicate = () => {
        setIsModalDuplicate(false);
    };

    const handleOpenModalRename = (data) => {
        setDropdownVisible(false);
        setCurrentProjectId(data.id);
        setCurrentFileId(data.upload);
        setProjectName(data.name);
        setIsModalRename(true);
    };

    const handleProjectName = (e) => {
        setProjectName(e.target.value);
    };

    const handleOkRename = () => {
        changeProjectName(currentProjectId, projectName).then((res) => {
            if (res.status == 200) {
                if (location == 'home') {
                    let cloneDataTable = cloneDeep(dataTable);

                    let fileIndex = cloneDataTable
                        .map((x) => {
                            return x.id;
                        })
                        .indexOf(currentFileId);

                    let projectIndex = cloneDataTable[fileIndex].projects
                        .map((x) => {
                            return x.id;
                        })
                        .indexOf(currentProjectId);

                    cloneDataTable[fileIndex].projects[projectIndex]['name'] =
                        projectName;
                    setDataTable(cloneDataTable);
                    handleTableRender();
                } else if (location == 'project') {
                    handleRefreshProject();
                }

                setIsModalRename(false);
            }
        });
    };

    const handleCancelRename = () => {
        setIsModalRename(false);
    };

    const handleProjectDelete = (data) => {
        console.log('handleOkDelete 111');
        setCurrentFileId(data.upload);
        setCurrentProjectId(data.id);
        setIsModalDelete(true);
    };

    const handleOkDelete = () => {
        console.log('handleOkDelete');
        deleteProject(currentProjectId).then((res) => {
            setIsModalDelete(false);
            if (res.status == 204) {
                let cloneDataTable = cloneDeep(dataTable);

                let fileIndex = cloneDataTable
                    .map((x) => {
                        return x.id;
                    })
                    .indexOf(currentFileId);

                let projectIndex = cloneDataTable[fileIndex].projects
                    .map((x) => {
                        return x.id;
                    })
                    .indexOf(currentProjectId);

                let items = cloneDataTable[fileIndex].projects;

                items = items.filter((item) => item !== currentProjectId);

                setDataTable(cloneDataTable);

                message.success('Project deleted successfully!');
                handleTableRender();
            }
        });
    };

    const handleCancelDelete = () => {
        setIsModalDelete(false);
    };

    return (
        <>
            <div
                className="dropdown flex-center"
                onClick={handleOpen}
                ref={ref}
            >
                <Button
                    style={{
                        border: 'none',
                        backgroundColor: 'transparent',
                        boxShadow: 'none'
                    }}
                    shape="circle"
                >
                    <img src={icon_menu_dots} className="icon-menu-dots-svg" />
                </Button>
                {dropdownVisible && (
                    <div className="dropdown-content-visible">
                        {/* <button
                            onClick={(e) => {
                                handleOpenModalRename(row);
                            }}
                            className="button-dropdown"
                        >
                            Rename Project
                        </button>
                        <button
                            onClick={() => {
                                handleOpenModalDuplicate(row);
                                setDropdownVisible(false);
                            }}
                            className="button-dropdown"
                        >
                            Duplicate Project
                        </button>

                        {hideExportAnalysis ? null : (
                            <button
                                onClick={() => {
                                    // downloadProjectFile(row.id);
                                    // setDropdownVisible(false);
                                    appContext.setIsModalExport(true);
                                }}
                                className="button-dropdown"
                            >
                                Export Analysis
                            </button>
                        )}

                        <button
                            onClick={() => {
                                downloadProjectFile(row.id);
                                setDropdownVisible(false);
                            }}
                            className="button-dropdown"
                        >
                            Export Project Dataset
                        </button> */}

                        {hideDelete ? null : (
                            <button
                                className="button-dropdown"
                                onClick={() => {
                                    handleProjectDelete(row);
                                    setDropdownVisible(false);
                                }}
                            >
                                Delete Project
                            </button>
                        )}
                    </div>
                )}
            </div>
            {(dropdownVisible ||
                isModalDelete ||
                isModalRename ||
                isModalDuplicate) && (
                <>
                    <DeleteModal
                        visible={isModalDelete}
                        onAccept={handleOkDelete}
                        onCancel={handleCancelDelete}
                        modalType="deleteProject"
                    />

                    {/* <RenameModal
                        visible={isModalRename}
                        onAccept={handleOkRename}
                        onCancel={handleCancelRename}
                        handleNewRename={handleProjectName}
                        currentName={projectName}
                        modalType="renameProject"
                    />

                    <ProjectDuplicateModal
                        visible={isModalDuplicate}
                        onAccept={handleOkDuplicate}
                        onCancel={handleCancelDuplicate}
                        handleProjectName={handleProjectName}
                        projectName={projectName}
                        modalType="duplicateProject"
                    /> */}
                </>
            )}
        </>
    );
};

export default ProjectDropdownToUnfinishedData;
